import { render, staticRenderFns } from "./TemplateSimple.vue?vue&type=template&id=386d0d68&"
import script from "./TemplateSimple.vue?vue&type=script&lang=js&"
export * from "./TemplateSimple.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSimple.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VCard,VCardText,VContainer})
